import store from "../store";
import Cookies from "universal-cookie";
import serverBaseURL from "./serverSetup";

const AA_GLOBAL = {
  baseURL: serverBaseURL(),
  cookies: new Cookies(),
  breakExtraSmall: 736,
  breakSuperSmall: 460,
  $audioThumbnailCol: "#737373",
  $alertCol: "#ff6464",
  $mainTextColor: "#737373",
  authCookieExpireData: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // 1 year
  emailRegex: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
  // @todo: other Unicode alphabetical letters should also be accepted.
  userPassRegex: /^(?=.*[a-zäöü])(?=.*\d).{8,}$/i,
  loaderLoadingDuration: 1500,
};

AA_GLOBAL.globalFormioOpts = { baseUrl: "/", i18n: {}, language: "en", noAlerts: true };

AA_GLOBAL.makeEditEntryUrl = (entryID, entryMenu) => {
  const { user } = store.getState();
  const chosenStep = AA_GLOBAL.getUnfinishedStep(entryMenu.requirement_steps);
  return `/ui/${user.role_selected}/edit-entry/${entryID}/${chosenStep.id}`;
};

AA_GLOBAL.firstUnfinishedStep = steps =>
  (steps || []).reduce(
    (acc, step) =>
      acc || AA_GLOBAL.firstUnfinishedStep(step.requirement_steps) || (!step.confirmed && step),
    null
  );

AA_GLOBAL.getUnfinishedStep = steps => AA_GLOBAL.firstUnfinishedStep(steps) || steps.slice(-1)[0];

// Pseudo role in the role menu: jumps to the DIY editor on the setup host.
// Only sent by the staging backend, for users owning the "diy" role.
AA_GLOBAL.editorRoleKey = "__editor";

AA_GLOBAL.withEditorItem = (menu, user, intl) =>
  user && user.editor_url
    ? [
        ...menu,
        {
          id: menu.length,
          key: AA_GLOBAL.editorRoleKey,
          label: intl.formatMessage({ id: "editor" }),
        },
      ]
    : menu;

AA_GLOBAL.switchUserRole = (selectedRole, { history }) => {
  if (selectedRole === AA_GLOBAL.editorRoleKey) {
    window.location.href = store.getState().user.editor_url;
  } else if (selectedRole === "config_admin") {
    window.location.href = "/configuration";
  } else if (selectedRole === "diy") {
    window.location.href = "/diy";
  } else if (selectedRole === "reviewer" || selectedRole === "review_admin") {
    // The review boards live in LiveView outside the SPA.
    window.location.href = `/${selectedRole}/dashboard`;
  } else {
    history.push(`/ui/${selectedRole}/dashboard`);
  }
};

export default AA_GLOBAL;
